var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "ticket-history" } },
    [
      _c("div", { attrs: { id: "visitor-history-row" } }, [
        _c("div", { staticClass: "left" }, [
          _c(
            "div",
            { staticClass: "pagination-toolbar" },
            [
              _vm.ticketHistory.count > 0
                ? _c("div", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          Math.min(
                            Math.max(
                              1,
                              (_vm.queries.pageCount - 1) * _vm.queries.perPage
                            ),
                            _vm.ticketHistory.count
                          )
                        ) +
                        " -\n                    " +
                        _vm._s(
                          Math.min(
                            Math.max(
                              1,
                              _vm.queries.pageCount * _vm.queries.perPage
                            ),
                            _vm.ticketHistory.count
                          )
                        ) +
                        " of\n                    " +
                        _vm._s(_vm.ticketHistory.count) +
                        " tickets\n                "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "a-button-group",
                [
                  _c("a-button", {
                    attrs: {
                      icon: "left",
                      disabled:
                        _vm.ticketHistory.count === 0 || !_vm.prevAvailable(),
                    },
                    on: { click: _vm.prevPage },
                  }),
                  _vm._v(" "),
                  _c("a-button", {
                    attrs: {
                      icon: "right",
                      disabled:
                        _vm.ticketHistory.count === 0 || !_vm.nextAvailable(),
                    },
                    on: { click: _vm.nextPage },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-popover",
                {
                  attrs: {
                    placement: "bottom",
                    overlayClassName: "btnPerPagePopover",
                    visible: _vm.pageSizeChangerVisible,
                  },
                  on: {
                    visibleChange: function ($event) {
                      _vm.pageSizeChangerVisible = !_vm.pageSizeChangerVisible
                    },
                  },
                },
                [
                  _c("template", { slot: "content" }, [
                    _c(
                      "div",
                      { staticClass: "page-options" },
                      _vm._l(
                        [1, 10, 20, 30, 50, 75, 100, 150, 200],
                        function (val) {
                          return _c(
                            "div",
                            {
                              key: val,
                              staticClass: "item",
                              on: {
                                click: function ($event) {
                                  return _vm.changePerPage(val)
                                },
                              },
                            },
                            [
                              _c("span", { staticClass: "value" }, [
                                _vm._v(_vm._s(val)),
                              ]),
                            ]
                          )
                        }
                      ),
                      0
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      staticClass: "btnPerPage",
                      on: {
                        click: function ($event) {
                          _vm.pageSizeChangerVisible = true
                        },
                      },
                    },
                    [
                      _c("SortIcon"),
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("message.perPageInFilter")) +
                          ": " +
                          _vm._s(_vm.queries.perPage) +
                          "\n                        "
                      ),
                      _c("a-icon", { attrs: { type: "caret-down" } }),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "right" },
          [
            _c(
              "b-form-group",
              {
                staticClass: "custom-input",
                attrs: {
                  id: "start-date-input-group",
                  label: _vm.$t("message.first"),
                  "label-for": "start-date-input",
                  "label-sr-only": "",
                },
              },
              [
                _c("datetime", {
                  attrs: {
                    "max-datetime": _vm.maxDate,
                    "min-datetime": _vm.lastFiveYear,
                    phrases: _vm.phrases,
                    placeholder: _vm.$t("message.startDate"),
                    auto: "",
                    "input-class": "form-control rounded-0",
                    "input-id": "start-date-input",
                    type: "datetime",
                  },
                  model: {
                    value: _vm.queries.dateBegin,
                    callback: function ($$v) {
                      _vm.$set(_vm.queries, "dateBegin", $$v)
                    },
                    expression: "queries.dateBegin",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-form-group",
              {
                staticClass: "custom-input",
                attrs: {
                  id: "end-date-input-group",
                  label: _vm.$t("message.last"),
                  "label-for": "end-date-input",
                  "label-sr-only": "",
                },
              },
              [
                _c("datetime", {
                  attrs: {
                    "max-datetime": _vm.maxDate,
                    "min-datetime": _vm.lastFiveYear,
                    phrases: _vm.phrases,
                    placeholder: _vm.$t("message.endDate"),
                    auto: "",
                    "input-class": "form-control rounded-0",
                    "input-id": "end-date-input",
                    type: "datetime",
                  },
                  model: {
                    value: _vm.queries.dateEnd,
                    callback: function ($$v) {
                      _vm.$set(_vm.queries, "dateEnd", $$v)
                    },
                    expression: "queries.dateEnd",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-form-group",
              {
                staticClass: "custom-input",
                attrs: {
                  id: "query-input-group",
                  label: _vm.$t("message.query"),
                  "label-for": "query-input",
                  "label-sr-only": "",
                },
              },
              [
                _c("b-form-input", {
                  staticClass: "rounded-0",
                  attrs: {
                    id: "query-input",
                    placeholder: _vm.$t("message.query"),
                    name: "query",
                  },
                  model: {
                    value: _vm.queries.query,
                    callback: function ($$v) {
                      _vm.$set(_vm.queries, "query", $$v)
                    },
                    expression: "queries.query",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-form-group",
              { staticClass: "custom-input" },
              [
                _c("a-rate", {
                  attrs: { "allow-clear": true },
                  model: {
                    value: _vm.queries.rate,
                    callback: function ($$v) {
                      _vm.$set(_vm.queries, "rate", $$v)
                    },
                    expression: "queries.rate",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-form-group",
              { staticClass: "custom-input" },
              [
                _c(
                  "b-form-select",
                  {
                    staticClass: "mb-3",
                    model: {
                      value: _vm.queries.assignedUser,
                      callback: function ($$v) {
                        _vm.$set(_vm.queries, "assignedUser", $$v)
                      },
                      expression: "queries.assignedUser",
                    },
                  },
                  [
                    _c("option", { domProps: { value: null } }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("message.allUsers")) +
                          "\n                    "
                      ),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.usersFilter.data, function (item) {
                      return _c(
                        "option",
                        { key: item._id, domProps: { value: item._id } },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(item.name) +
                              "\n                    "
                          ),
                        ]
                      )
                    }),
                  ],
                  2
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-form-group",
              { staticClass: "custom-input" },
              [
                _c(
                  "b-form-select",
                  {
                    staticClass: "mb-3",
                    model: {
                      value: _vm.queries.status,
                      callback: function ($$v) {
                        _vm.$set(_vm.queries, "status", $$v)
                      },
                      expression: "queries.status",
                    },
                  },
                  [
                    _c("option", { domProps: { value: null } }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("message.allStatus")) +
                          "\n                    "
                      ),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.statuses, function (item) {
                      return _c(
                        "option",
                        { key: item._id, domProps: { value: item.title } },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(item.title) +
                              "\n                    "
                          ),
                        ]
                      )
                    }),
                  ],
                  2
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("ArchiveComponent", {
        attrs: {
          type: "ticket",
          "hide-filters": true,
          "is-archive": false,
          "selected-time": _vm.timeSelect,
          "table-data": _vm.ticketHistory.tickets.map(function (x) {
            return Object.assign({}, x, {
              fullname: !!x.osrPayload
                ? x.osrPayload["fullname"]
                : !!x.conversation
                ? x.conversation["fullname"]
                : "-",
              email: !!x.osrPayload
                ? x.osrPayload["email"]
                : !!x.conversation
                ? x.conversation["email"]
                : "-",
              phone: !!x.osrPayload
                ? x.osrPayload["phone"]
                : !!x.conversation
                ? x.conversation["phone"]
                : "-",
            })
          }),
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }